import { ADMINISTRATIVE_CONFIG_PATH } from '../../administrative-config/constants';

const CODE_SYSTEM_BASE_PATH = `${ADMINISTRATIVE_CONFIG_PATH}/code-system`;

export const COMMLOG_TOPICS = {
  path: `${CODE_SYSTEM_BASE_PATH}/communication-topics`,
  text: 'Comm Log Topics',
  module: 'administrative-config-code-system',
  component: 'Dashboard',
};

export const ADMISSION_CANCEL_REASON = {
  path: `${CODE_SYSTEM_BASE_PATH}/admission-cancellation-reason`,
  text: 'Adm Canc Reasons',
  module: 'administrative-config-code-system',
  component: 'Dashboard',
};

export const DISCHARGE_REASON = {
  path: `${CODE_SYSTEM_BASE_PATH}/discharge-reason`,
  text: 'Discharge Reasons',
  module: 'administrative-config-code-system',
  component: 'Dashboard',
};
